const Add = () => (
  <>
    <path
      fill="currentColor"
      d="M11.5 12.5h-5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 6.5 11.5h5v-5q0-.213.144-.356A.49.49 0 0 1 12.001 6q.212 0 .356.144a.49.49 0 0 1 .143.356v5h5q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143h-5v5q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.48.48 0 0 1-.143-.356z"
    />
  </>
)
export default Add
